import React, { createContext, ReactElement } from 'react'
// Utilities imports.
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'

/**
 * Language context properties type.
 */
export type LanguageContextType = CLanguageHandler | undefined

/**
 * Component properties type.
 */
type Props = {
    children: React.ReactNode
}

/**
 * Provides access to language resources.
 * @param children Children to render.
 */
export const LanguageContextProvider = ({ children }: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()

    return <LanguageContext.Provider value={language}>{children}</LanguageContext.Provider>
}

/**
 * Context for language resources.
 */
const LanguageContext = createContext<LanguageContextType>(undefined)
export default LanguageContext
